import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { AppKeyService } from '../appkey';
import { ICompany, ICompanyWithOptionals } from './_models';

export * from './_models';

@Injectable({
	providedIn: 'root'
})
export class CompanyService {
	public isAdmin: boolean;
	public company: ICompany;

	constructor(
		private appKeyService: AppKeyService
	) {}

	/**
	 * Clear service cache
	 */
	public clearCache(): void {
	}

	/**
	 * If we have apps then we are a compamy admin and can mock the SBC Company (the server no longer has a concept of a company)
	 */
	public getCompany(): Observable<ICompany> {

		return new Observable<ICompany>((observer) => {
			this.appKeyService.getAll().subscribe(
				(result) => {
					if (result && Object.keys(result).length > 0) {
						this.isAdmin = true;
						this.company = { id: "sbc", name: "Specialized Bikes" };
					} else {
						this.company = undefined;
						this.isAdmin = false;
					}

					observer.next(this.company);
					observer.complete();
				},
				(error) => {
					observer.error(error);
					observer.complete();
				}
			);
		});
	}

	/**
	 * Check if user is admin contact in provided company.
	 */
	public isAdminContact(): boolean {
		return this.isAdmin;
	}
}
